module.exports = __webpack_public_path__ + "img/1-1.cab96d27.svg";